export const getTextAdPlacementStyles = () => ({
  placementCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',

    position: 'relative',
    boxSizing: 'content-box',
    overflow: 'hidden',
    background: 'transparent',
    margin: 'auto',
    padding: '8px 16px',

    '& .card-parent': {
      width: '100%',
    },
    '& .placement-card-content': {
      width: '100%',
      height: '100%',
      display: 'block',
      overflow: 'hidden',
      boxSizing: 'border-box',
    },
  },
  placementTextContainer: {
    margin: '16px',
    fontSize: 10,
    lineHeight: '16px',
    color: '#0078d4',
    overflow: 'hidden',
    '&:hover': {
      color: '#004578',
    },
  },
  placementLongHeadline: {
    display: 'inline',
    height: 28,
    fontSize: 20,
    fontWeight: 400,
    lineHeight: '24px',
    overflow: 'hidden',
    color: '#4007A2',
  },
  placementFinalUrl: {
    lineHeight: '22px',
    fontWeight: 700,
    fontSize: 16,
    color: '#006621',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  placementBusinessNameWithAdsLabel: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '22px',
    color: '#666666',
    margin: '5px 0',
  },
  placementCallToAction: {
    border: '1px solid #DDDDDD',
    background: '#F5F5F5',
    width: 92,
    height: 28,
    borderRadius: 16,
    padding: '0px, 15px, 0px, 15px',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '22px',
    color: '#666666',
  },
});
